import React, { useState, createContext, useContext } from 'react';
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import ActivateAccountDialog from "../../pages/Accounts/ActivateAccountDialog";
import AddDomainDialog from "../../pages/Domains/AddDomainDialog";

const initalState = {
  showModal: () => {},
  hideModal: () => {},
  showDialog: () => {},
  showConfirmDialog: () => {},
  showAccountActivationDialog: () => {},
  store: {},
};

const dialogs = {
  confirm: ConfirmDialog,
  activateAccount: ActivateAccountDialog,
  addDomain: AddDomainDialog
}

const GlobalModalContext = createContext(initalState);
export const useGlobalModalContext = () => useContext(GlobalModalContext);

export const GlobalModal = ({ children }) => {
  const [store, setStore] = useState({});
  const { modalType, modalProps } = store || {};

  const showModal = (modalType, modalProps = {}) => {
    setStore({
      ...store,
      modalType,
      modalProps,
    });
  };

  const showDialog = (type, title = "", dialogProps = {}) => {
    return new Promise(function (resolve, reject) {
      setStore({
        ...store,
        modalType: type,
        modalProps: {
          ...dialogProps,
          onClose: (result) => {hideModal();resolve(result);},
          title
        }
      });
    });
  }

  const showConfirmDialog = (title, text, dialogProps = {}) => {
    return showDialog('confirm', title, {...dialogProps, text});
  }

  const hideModal = () => {
    setStore({
      ...store,
      modalType: null,
      modalProps: {},
    });
  };

  const renderComponent = () => {
    const ModalComponent = dialogs[store.modalType];
    if (!modalType || !ModalComponent) {
      return null;
    }

    return <ModalComponent {...modalProps}>{modalProps.text}</ModalComponent>;
  };

  return (
    <GlobalModalContext.Provider value={{ store, showModal, hideModal, showDialog, showConfirmDialog }}>
      {renderComponent()}
      {children}
    </GlobalModalContext.Provider>
  );
};